import React, { ChangeEvent, useState } from 'react';
import styled from 'styled-components'
import useAsyncEffect from 'use-async-effect';
import Autocomplete from "react-google-autocomplete";

import AnimatedSaveButton from '../AnimatedSaveButton';
import FormTextItem from '../form/FormTextItem';
import ServiceOrder from '../../model/ServiceOrder';
import ServiceOptionItem from './ServiceOptionItem';
import ServiceOption from '../../model/ServiceOption';
import api from '../../api/api';
import FormDateItem from '../form/FormDateItem';

const Style = styled.div`



@media (min-width: 1200px){
    max-width:1200px;
    margin:auto;
}

h2 {
    font-size: 1.2rem;
}
input[type='checkbox'] {
    height: 1.5rem;
}
.content {
    padding: 0 1rem 10rem 1rem;
}
.top-header{
    color:#01133E;
}

.light {
background-color: #00B5D1;
color:#fff;
padding: 0.5rem;
}
header{
    display: flex;
    flex-direction: row-reverse;
}
.form-item {
    margin-right: 1rem;
}
.submit-panel {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;

    @media (min-width: 1200px){
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        gap: 0;
    }
}
.row {
    display: flex;
    flex-direction: column;

    @media (min-width: 1200px){
        flex-direction: row;
    }

    margin: 2rem 0;        
}
.last-row-item {
    flex-basis: 60%;
}
.setup-requirements {
    
    margin: 2rem 0;
    
    label {
        margin-left: 1rem;
    }

    & > div {
        display: flex;
        align-items: center;
    }
}
.margin-top{
    margin-top: 2.5rem;
}
.services-container {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    @media (min-width: 1200px){
        margin-top: 2.5rem;
        justify-content: space-between;
        flex-direction: row;
    }    
}

.service-option {
    margin-top: 2.5rem;
    @media (min-width: 1200px){
        margin-top: 0;
    }    
}

.provision{
    background-color: #00B5D1;
    color: #fff;
    padding: 1rem;
    margin: 1rem 0
}
.error{
    color: #7b0100;
    background-color: #f5cccc;
    border-color: #f0b3b3;  
    padding: 1rem;
    margin: 1rem 0
}
input[type="radio"] {
    height: 1rem;   
    width :auto;
    margin-right: 1rem;
}
.radio-inline{
    display:flex;
    margin: 1rem 0;
}
.email-marketing-info {
    font-size: 0.8rem;
    font-style: italic;;
}
.terms {
    font-size: 0.8rem;
}

`;



const NewOrderPage:React.FC = (props:any) => {
    const showSaveButton = true;
    const [ order, setOrder ] = useState<ServiceOrder>({isAnnual:true,sendPriceSensitiveAnnouncements:false,sendNonPriceSensitiveAnnouncements:false,autoSendAnnouncementEmail:false,autoSendNonPriceSensitiveAnnouncements:false} as any);
    const [ submitted, setSubmitted ] = useState<boolean>(false);
    const [ serviceOptions, setServiceOptions ] = useState<ServiceOption[]>([]);
    const [ loaded, setLoaded ] = useState<boolean>(false);
    const [ errors, setErrors ] = useState<string[]>([]);        
    
    const [address, setAddress] = useState('');
    
    const onChange = (e:any) => {  
        
        onChanged(e.target.name, e.target.value);         
    }

    


    const onChanged = (name:string, value:any) => {
        
        const clone:any = { ...order }
        clone[name] = value;
        setOrder(clone)  
    }

    const submit:()=>Promise<boolean> = async () => {
        
        setErrors([]);
        const errs:string[] = []
        if(!order.companyName){
            errs.push('Company Name Required')
        }
        if(!order.ticker){
            errs.push('Ticker/ASX Code Required')
        }
        if(!order.website){
            errs.push('Website Required')
        }
        if(!address){
            errs.push('Address Required')
        }
        if(!order.contactName){
            errs.push('Contact Name Required')
        }
        if(!order.contactPhone){
            errs.push('Contact Phone Required')
        }

        if(!order.contactEmail){
            errs.push('Contact Email Required')
        }
        if(!order.abn){
            errs.push('ABN Required')
        }
        if(!order.authorisedBy){
            errs.push('Authorised By Required')
        }
        if(!order.authorisedByEmail){
            errs.push('Authorised By Email Required')
        }
        if(!order.option){
            errs.push('A service option must be selected')
        }
        if(!order.agreedToTerms){
            errs.push('You must agree to the terms of this order')
        }
        if(errs.length){
            setErrors(errs);
            return false;
        }
        order.address = address;
        const result = await api().saveServiceOrder(order);
        if(result.errors && result.errors.length){
            setErrors(result.errors);
            return false;
        }
        setSubmitted(true);

        return true;
    }

    useAsyncEffect(async (isMounted)=>{
        const result = await api().getServiceOptions(props.match.params.id);
        if(isMounted()){
            setServiceOptions(result.options);
            onChanged('option', result.options.find(x=>x.isDefault) || result.options[0])
            setLoaded(true);
        }
    }, []);

    
   const autoSendConfigurationChanged = (e:ChangeEvent<HTMLInputElement>) => {
    const clone:ServiceOrder = { ...order }
        
    clone.sendPriceSensitiveAnnouncements = true;
    clone.sendNonPriceSensitiveAnnouncements = true;
    clone.autoSendAnnouncementEmail = false;
    clone.autoSendNonPriceSensitiveAnnouncements = false;

    if(e.target.value === 'all'){
        clone.autoSendAnnouncementEmail = true;
        clone.autoSendNonPriceSensitiveAnnouncements = true;
    }
    else if(e.target.value === 'price_sensitive_only'){
        clone.autoSendAnnouncementEmail = true;
    }

    setOrder(clone)  
    console.log('clone', clone)
   }


    
    const disabled = submitted;

    if(!loaded) return null;

    return <Style>

        <header className="header">
            <img src="/images/logo.svg" alt="logo" className="front-page-logo" />
        </header>

        <div className="content">

        <h2 className='top-header'>INVESTI SERVICES PTY LTD (ABN 81 619 772 968) ORDER FORM</h2>
        <p>Please complete the following details for implementation.</p>

        <h2 className='margin-top'>COMPANY DETAILS</h2>

        <div className='row'>
            <FormTextItem label="Name of Company" name='companyName' value={order.companyName} onChange={onChange} disabled={disabled} required />
            <FormTextItem label="Ticker/ASX Code" name='ticker' value={order.ticker} onChange={onChange} disabled={disabled} />
            <FormDateItem label="Listing date (IPO only)" name='listingDate' value={order.listingDate} onChange={onChange} disabled={disabled} />            
            <FormTextItem label="URL (Address) of Company Website where the data will appear." name='website' value={order.website} onChange={onChange} className="last-row-item" disabled={disabled} />
        </div>

        <div className='row'>
            <FormTextItem label="Billing Contact Name" name='contactName' value={order.contactName} onChange={onChange} disabled={disabled} />
            <FormTextItem label="Billing Contact Phone" name='contactPhone' value={order.contactPhone} onChange={onChange} disabled={disabled} />
            <FormTextItem label="Billing E-Mail" name='contactEmail' value={order.contactEmail} onChange={onChange} className="last-row-item" disabled={disabled} />
        </div>
        <div className='row'>
            <FormTextItem label="ABN" name='abn' value={order.abn} onChange={onChange} disabled={disabled} />
            {/* <FormTextItem label="Billing address" name='address' value={order.address} onChange={onChange} className="last-row-item" disabled={disabled} /> */}
            <div className="form-item last-row-item">
            <div><label htmlFor="">Billing address</label></div>
            <Autocomplete 
                    defaultValue={address}                    
                    apiKey="AIzaSyB_NyqA_6mTi-VqMdL18rO0uEm8YRKve4k"                    
                    placeholder={"Please enter the address"}                    
                    //onChange={e=> onChanged('address', (e.target as HTMLInputElement).value)}                    
                    onChange={e=> setAddress((e.target as HTMLInputElement).value)}                    
                    
                    onPlaceSelected={p => {                        
                        //onChanged('address', p.formatted_address || p.name)
                        setAddress(p.formatted_address || p.name)
                    }}                    
                    options={ {types: ['address']}}
                    
                    />
            </div>
            
            
        </div>

        <h2 className='margin-top'>SERVICES</h2>

        <div className='billing-frequency'>
            <label style={{ marginRight: '1rem' }}> 
                <input type="radio" name="isAnnual" checked={order.isAnnual === true}
                    onChange={() => onChanged('isAnnual', true)} disabled={disabled} /> Annual billing
            </label>
            {/* <label >
                <input type="radio" name="isAnnual" checked={order.isAnnual === false}
                    onChange={() => onChanged('isAnnual', false)} disabled={disabled} /> Monthly billing
            </label> */}
            
        </div>

        <div className='services-container'>
            {serviceOptions.map((x, i) => <ServiceOptionItem
                key={i}
                index={serviceOptions.length > 1 ? i + 1 : undefined}
                item={x}
                isAnnual={order.isAnnual}
                disabled={disabled}
            ></ServiceOptionItem>)}



        </div>

        <hr />

        <div>
        <h2 className='margin-top'>Email Marketing settings (optional)</h2>
         <div className='email-marketing-info'>
            ASX Announcements can be automatically sent to your subscriber base using Mailchimp, Campaign Monitor or our in-house Campaign creator
            </div>       
       
        <div >
            <label className="radio-inline">
                <input type="radio" value="all" name="autoSendConfiguration" onChange={autoSendConfigurationChanged} checked={order.autoSendAnnouncementEmail && order.autoSendNonPriceSensitiveAnnouncements} /> Auto send ALL announcements
            </label>
            <label className="radio-inline">
                <input type="radio" value="price_sensitive_only" name="autoSendConfiguration" onChange={autoSendConfigurationChanged} checked={order.autoSendAnnouncementEmail && !order.autoSendNonPriceSensitiveAnnouncements} /> Auto send price sensitive only
            </label>
            <label className="radio-inline">
                <input type="radio" value="manual" name="autoSendConfiguration" onChange={autoSendConfigurationChanged} checked={!order.autoSendAnnouncementEmail && !order.autoSendNonPriceSensitiveAnnouncements && order.sendPriceSensitiveAnnouncements && order.sendNonPriceSensitiveAnnouncements} /> Manually confirm each announcement
            </label>
        </div>

                    <div className='row'>
        <FormTextItem label="Confirmation Emails" helperText="Recipients will receive the Mailchimp 'Send Now' email"  name='confirmationEmail' value={order.confirmationEmail!} onChange={onChange}/>                    
        </div>
        

        </div>

        <h2 className='margin-top'>TERMS AND CONDITIONS</h2>

        <div className='terms'>
        <p>Annual subscriptions are billed 12 months in advance and have a minimum term of 12 months; monthly
            subscriptions are billed one month in advance and continue month to month. All prices are quoted
            exclusive of GST. Payment is required within 7 days from issue of invoice to ensure no interruption
            to ongoing service. We may suspend the service where an invoice remains unpaid after the due date.
            Notice for cancellation must be provided in writing to contact@investi.com.au prior to the
            commencement of the next billing cycle. Fees may be varied with 30 days' written notice, effective
            from your next billing cycle.</p>

        <p>All software, widgets, feeds and associated intellectual property remain our property. You are granted
            a non-exclusive, non-transferable licence to display the service on your own website for the duration
            of your subscription; the service may not be resold or redistributed without our written consent.
            Subscriber lists collected through the service remain your property and any personal information is
            handled in accordance with the Privacy Act 1988 (Cth).</p>

        <p>We take reasonable steps to keep the service available and accurate, however the service is provided
            "as is" and we do not warrant that it will be uninterrupted or error-free; scheduled maintenance is
            performed outside business hours (AEST) where practicable. Either party may terminate for a material breach that remains unremedied
            14 days after written notice. To the maximum extent permitted by law, our liability arising out of or
            in connection with the service is limited to the fees paid in the preceding 12 months.</p>
        </div>

        <hr style={{marginTop:'6rem'}}/>

        {showSaveButton && <div className='submit-panel'>
            <label style={{ display: 'flex', alignItems: 'center', marginRight: '1rem', fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                <input type="checkbox" checked={order.agreedToTerms === true} style={{ marginRight: '0.5rem' }}
                    onChange={e => onChanged('agreedToTerms', e.target.checked)} disabled={disabled} />
                I agree to the terms and conditions above
            </label>
            <FormTextItem label="Authorised By (your name)" name='authorisedBy' value={order.authorisedBy} onChange={onChange} disabled={disabled} />
            <FormTextItem label="Authorised By Email" name='authorisedByEmail' value={order.authorisedByEmail} onChange={onChange} disabled={disabled} />
            <AnimatedSaveButton onClick={submit} startingText="Submit Order Form" progressText="Submitting" completedText="Submitted" disabled={disabled} />
        </div>
        }

        {!!errors.length && <div className='error'>
            <ul >
                {errors.map((x, i) => <li key={i}>{x}</li>)}
            </ul>
        </div>}


        {submitted && <div className='provision'>
            <p>Thank you for your order</p>
            <p>We will provision your service shortly and email you the API Key and development implementation details</p>
        </div>}

        </div>

    </Style>
}

export default NewOrderPage;